import './App.css';
import NavBar from './components/NavBar';
import About from "./pages/About";
import Appointment from "./pages/Appointment";
import Contact from './pages/Contact';
import Home from './pages/Home'
import './styles.css';
import "@fontsource/roboto";
import "@fontsource/inter";



function App() {
  let component = Home
  switch(window.location.pathname) {
    case "/":
      component = <Home />
      break
    case "/about":
      component = <About />
      break
    case "/appointment":
      component = <Appointment />
      break
    case "/contact":
      component = <Contact />
      break
    default:
      break
  }

  return (
    <>
      <NavBar />
      {component}
    </>
  );
}

export default App;
